<template>
  <InstructorCard
    :instructor="item"
    :is-mobile="state.isMobile"
  />
</template>

<script src="./instructor.js"></script>
<style lang="scss" scoped src="./instructor.scss"></style>